import { StyledScatterChart } from './ScatterChart.style';
import useFetchData from './useFetchData/useFetchData';
import Header from './Header';
import Graph from './Graph/Graph';
import getSkeltonByGraphType from '../../../CustomReport/Widgets/CustomWidget/EmptyStates/skeletons/widget.skeleton';
import { GRAPH_TYPES } from '../../../CustomReport/consts';

const ScatterChart = () => {
  const { data, isLoading } = useFetchData();
  const LoadingSkeleton = getSkeltonByGraphType(GRAPH_TYPES.AREA_SPLINE);
  if (isLoading)
    return (
      <StyledScatterChart>
        <LoadingSkeleton />
      </StyledScatterChart>
    );

  return (
    <StyledScatterChart>
      <Header data={data} />
      <Graph data={data} />
    </StyledScatterChart>
  );
};

export default ScatterChart;
